/*
  Plate bracket finder (CHR-44). Markup + data: snippets/ccw-plate-finder.liquid.

  Steps collapse as they're answered: vehicle finder -> one-line vehicle bar,
  then (only when the kit has a wireless version) a wired / wireless tile pick.
  Resolution order on load: a kit bundle in the cart, then the saved garage
  vehicle, else wait for the finder. Wired always fits; wireless only fits a
  CorbinLink Wireless kit, so "Not sure" picks wired.

  Top price: while locked it shows a range (whole product, then just this
  machine's options); once a bracket is chosen the theme's own price shows.
*/
(function () {
  "use strict";

  var D = window.__CCW_PLATE__;
  var root = document.querySelector("[data-ccw-plate]");
  if (!D || !root) return;

  var body = document.body;
  var $ = function (sel) { return root.querySelector(sel); };
  var finderStep = $("[data-ccw-plate-finder-step]");
  var finderEl = $("[data-ccw-vehicle-finder]");
  var vehicleEl = $("[data-ccw-plate-vehicle]");
  var fitsEl = $("[data-ccw-plate-fits]");
  var kitEl = $("[data-ccw-plate-kit]");
  var unsureEl = $("[data-ccw-plate-unsure]");
  var pickEl = $("[data-ccw-plate-pick]");
  var pickImg = $("[data-ccw-plate-pick-img]");
  var pickName = $("[data-ccw-plate-pick-name]");
  var noteEl = $("[data-ccw-plate-note]");
  var browseEl = $("[data-ccw-plate-browse]");

  var current = null; // { wired, wireless }
  var chosenId = null; // the finder's current pick, restored when leaving browse

  body.classList.add("ccw-plate-mode", "ccw-plate-locked");

  function ids() {
    return Object.keys(D.variants).filter(function (k) { return D.variants[k]; });
  }

  function uniq(list) {
    var out = [];
    (list || []).forEach(function (id) {
      if (id && D.variants[id] && out.indexOf(id) === -1) out.push(id);
    });
    return out;
  }

  // Top price while locked: "$34.99 – $46.99", or one price when the range collapses.
  function setTopPrice(variantIds) {
    var box = document.querySelector(".product-block-group--price-value");
    if (!box) return;
    var el = box.querySelector(".ccw-plate-price");
    if (!el) {
      el = document.createElement("span");
      el.className = "ccw-plate-price m-price-item m:text-xl md:m:text-2xl";
      box.appendChild(el);
    }
    var vs = variantIds.map(function (id) { return D.variants[id]; }).filter(Boolean);
    if (!vs.length) return;
    vs.sort(function (a, b) { return a.cents - b.cents; });
    var lo = vs[0], hi = vs[vs.length - 1];
    el.textContent = lo.cents === hi.cents ? lo.price : lo.price + " – " + hi.price;
  }

  // Mixed-trim bundles list two brackets; the chosen trim decides.
  function pickForTrim(list, trim) {
    if (list.length < 2 || !trim) return list[0] || null;
    for (var i = 0; i < list.length; i++) {
      var t = D.variants[list[i]].trims;
      if (Array.isArray(t) && t.indexOf(trim) !== -1) return list[i];
    }
    return null;
  }

  function selectVariant(id) {
    var v = D.variants[id];
    if (!v) return;
    var picker = document.querySelector("variant-picker");
    if (picker) {
      var radios = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === v.option) {
          if (!radios[i].checked) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event("change", { bubbles: true }));
          }
          return;
        }
      }
      var select = picker.querySelector("select");
      if (select) {
        if (select.value !== v.option) {
          select.value = v.option;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
        return;
      }
    }
    document.querySelectorAll('form[data-type="add-to-cart-form"] [name="id"]').forEach(function (el) {
      el.value = id;
    });
  }

  function setNote(text, warn) {
    noteEl.textContent = text || "";
    noteEl.hidden = !text;
    noteEl.classList.toggle("ccw-plate__note--warn", !!warn);
  }

  function choose(id, note, warn) {
    chosenId = id;
    selectVariant(id);
    var v = D.variants[id];
    pickName.textContent = v.name;
    if (v.image) {
      pickImg.src = v.image;
      pickImg.hidden = false;
    } else {
      pickImg.hidden = true;
    }
    setNote(note, warn);
    pickEl.hidden = false;
    body.classList.remove("ccw-plate-locked");
  }

  function clearChoice() {
    chosenId = null;
    pickEl.hidden = true;
    setNote("");
    kitEl.querySelectorAll("input").forEach(function (i) { i.checked = false; });
    unsureEl.setAttribute("aria-pressed", "false");
    body.classList.add("ccw-plate-locked");
  }

  function showFinder() {
    if (kitRec) kitRec.hidden = true;
    current = null;
    clearChoice();
    kitEl.hidden = true;
    vehicleEl.hidden = true;
    finderStep.hidden = false;
    setTopPrice(ids());
  }

  function answerKit(kind) {
    if (!current) return;
    unsureEl.setAttribute("aria-pressed", String(kind === "unsure"));
    if (kind === "wireless") {
      choose(current.wireless, "Made for the CorbinLink Wireless kit. If your machine has a wired kit, pick Wired.", true);
    } else if (kind === "unsure") {
      kitEl.querySelectorAll("input").forEach(function (i) { i.checked = false; });
      choose(current.wired, "Not sure? This one fits either kit, so we picked it for you.");
    } else {
      choose(current.wired, "");
    }
  }

  // Kit pairing card below the fold (CHR-47). Hidden when the kit is already in the cart.
  var kitRec = document.querySelector("[data-ccw-plate-kitrec]");
  var kitInCart = false;

  function showKitRec(handle, label) {
    if (!kitRec) return;
    var b = D.bundles[handle];
    if (!b || !b.url || kitInCart) { kitRec.hidden = true; return; }
    var name = (b.title || "").replace(/ (Complete )?Turn Signal Kit Bundle$/, "");
    kitRec.innerHTML = "";
    if (b.image) {
      var img = document.createElement("img");
      img.src = b.image; img.alt = b.title || ""; img.width = 96; img.height = 96; img.loading = "lazy";
      kitRec.appendChild(img);
    }
    var body = document.createElement("div");
    var eyebrow = document.createElement("div");
    eyebrow.className = "ccw-plate-kitrec__eyebrow";
    eyebrow.textContent = "Turn signal kit for your machine";
    var title = document.createElement("div");
    title.className = "ccw-plate-kitrec__title";
    title.textContent = name + " Turn Signal Kit Bundle";
    var why = document.createElement("p");
    why.className = "ccw-plate-kitrec__why";
    why.textContent = "The bracket light wires into our turn signal kit harness. From " + b.price + ".";
    body.appendChild(eyebrow); body.appendChild(title); body.appendChild(why);
    kitRec.appendChild(body);
    var cta = document.createElement("a");
    cta.className = "m-button m-button--secondary ccw-plate-kitrec__cta";
    cta.href = b.url;
    cta.textContent = "View kit";
    kitRec.appendChild(cta);
    kitRec.hidden = false;
  }

  // label: what the vehicle bar says; kit: "wired" | "wireless" | null
  function resolve(handle, trim, label, kit) {
    showKitRec(handle, label);
    current = null;
    clearChoice();
    finderStep.hidden = true;
    vehicleEl.hidden = false;
    kitEl.hidden = true;
    fitsEl.textContent = label || "Your machine";

    var b = D.bundles[handle];
    var wired = pickForTrim(uniq(b && b.wired), trim);
    var wireless = uniq(b && b.wireless)[0] || null;

    if (!wired) {
      if (D.universal) {
        setTopPrice([D.universal]);
        choose(D.universal, "We don't make a vehicle-specific bracket for this machine. This universal lighted frame fits a standard plate and works with our kits.");
      }
      return;
    }

    current = { wired: wired, wireless: wireless };

    if (!wireless) {
      setTopPrice([wired]);
      choose(wired, "");
      return;
    }

    setTopPrice([wired, wireless]);
    $('[data-ccw-plate-price="wired"]').textContent = D.variants[wired].price;
    $('[data-ccw-plate-price="wireless"]').textContent = D.variants[wireless].price;
    kitEl.hidden = false;

    if (kit) {
      var input = kitEl.querySelector('input[value="' + kit + '"]');
      if (input) input.checked = true;
      answerKit(kit);
    }
  }

  function labelFor(year, make, trim) {
    return [year, make, trim].filter(Boolean).join(" ");
  }

  kitEl.addEventListener("change", function (e) {
    if (e.target && e.target.name === "ccw-plate-kit") answerKit(e.target.value);
  });
  unsureEl.addEventListener("click", function () { answerKit("unsure"); });
  $("[data-ccw-plate-change]").addEventListener("click", showFinder);

  root.addEventListener("ccw:finder_match", function (e) {
    var d = e.detail || {};
    var handle = d.match && d.match.route_product_handle;
    resolve(handle, d.trim, labelFor(d.year, d.make, d.trim), null);
  });

  var backEl = $("[data-ccw-plate-back]");

  browseEl.addEventListener("click", function () {
    body.classList.add("ccw-plate-browse");
    body.classList.remove("ccw-plate-locked");
    browseEl.hidden = true;
    backEl.hidden = false;
  });

  // Back from browse: restore the finder's own pick, or re-lock if there wasn't one.
  $("[data-ccw-plate-back-btn]").addEventListener("click", function () {
    body.classList.remove("ccw-plate-browse");
    browseEl.hidden = false;
    backEl.hidden = true;
    if (chosenId) {
      selectVariant(chosenId);
    } else {
      body.classList.add("ccw-plate-locked");
    }
  });

  function fromGarage() {
    var G = window.CCWGarage;
    if (!G || !G.get || !G.findMatch) return false;
    var g = G.get();
    if (!g.year || !g.make || !g.trim) return false;
    var m = G.findMatch(g.year, g.make, g.trim);
    if (!m || !m.route_product_handle) return false;
    resolve(m.route_product_handle, g.trim, labelFor(g.year, g.make, g.trim), null);
    return true;
  }

  function fromCart(cart) {
    var g = (window.CCWGarage && window.CCWGarage.get) ? window.CCWGarage.get() : {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var b = D.bundles[it.handle];
      if (!b) continue;
      var kit = /-RF/i.test(it.sku || "") ? "wireless" : "wired";
      // Only use the saved trim if it belongs to this same bundle.
      var trim = (g.featuredBundleHandle === it.handle) ? g.trim : null;
      if (uniq(b.wired).length > 1 && !pickForTrim(uniq(b.wired), trim)) continue;
      var name = it.product_title.replace(/ Turn Signal Kit Bundle$/, "");
      kitInCart = true;
      resolve(it.handle, trim, "Matched to your cart: " + name, kit);
      return true;
    }
    return false;
  }

  document.querySelectorAll("[data-ccw-plate-totop]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      root.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  });

  function init() {
    setTopPrice(ids());
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (!fromCart(cart)) fromGarage(); })
      .catch(function () { fromGarage(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
